import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ContextMHService, IContextMHServiceToken } from 'projects/munhowen/src/app/services/infrastructure/context.service';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-my-shop-toggle-button',
    templateUrl: './my-shop-toggle-button.component.html',
    standalone: false
})
export class MyShopToggleButtonComponent implements OnInit, OnDestroy {

  private readonly contextService: ContextMHService;
  private readonly authService: IAuthService;

  private contextSubscription: Subscription | undefined;
  private authenticationSubscription: Subscription | undefined;

  public isAuthenticated: boolean | undefined;
  public myShopActive: boolean | undefined;

  public constructor() {
    this.contextService = inject(IContextMHServiceToken);
    this.authService = inject(IAuthServiceToken);
  }

  public ngOnInit(): void {
    this.contextSubscriptionInit();
    this.authSubscriptionInit();
  }

  public ngOnDestroy(): void {
    this.contextSubscription?.unsubscribe();
    this.authenticationSubscription?.unsubscribe();
  }

  private contextSubscriptionInit() {
    if (!this.contextSubscription) {
      this.contextSubscription = this.contextService.contextUiRefreshChangedGet().pipe().subscribe(
        () => {
          this.myShopActive = this.contextService.isMyShopActive();
        }
      );
    }
  }

  private authSubscriptionInit() {
    if (!this.authenticationSubscription) {
      this.authenticationSubscription = this.authService.authenticatedGet().subscribe(
        (isAuthenticated) => {
          this.isAuthenticated = isAuthenticated;
        }
      );
    }
  }

  public shopContextToggle() {
    this.contextService.contextToggle();
  }

}
